import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker"
import moment from 'moment';
import Select from 'react-select';
import MatButton from '@mui/material/Button';
import "react-datepicker/dist/react-datepicker.css";
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import {
    FormGroup,
    Label,

} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    fetchTravelForm,
    addTravelForm,
    updateTravelForm,
    mailTravelForm
} from 'Actions';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class UpdateItem extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev: 0,
    };

    static num1 = 0;


    constructor(props) {

        super(props);        
        this.state = {
            student: '',
            travel: '',
            checkoutdate: new Date(this.props.data.edcheckoutdate),
            checkindate: new Date(this.props.data.edcheckindate),
            checkouttime: this.props.data.edcheckouttime,
            checkintime: this.props.data.edcheckintime,
            formValues: this.props.data.edformvalue,
            sepmore: this.props.data.edsepmore,
            result: this.props.data.edleavecnt,
            chkcount: this.props.data.edleavecnt,
            edacptcnt: this.props.data.edacptcnt,
            loader: false,
            loader2: false,
            chklist: 1,
        };

    }


    upDateHandleSubmit(event) {
        event.preventDefault();
        this.setState({ loader: true });
        var sepmore = this.state.sepmore;
        var leavecnt = this.state.result;

        this.props.updateTravelForm(event, sepmore, leavecnt).then((data) => {
            this.setState({ loader: false });
            if (data.status == 1) {
                document.getElementById("updateform").reset();
                setTimeout(this.props.onClick, 5000);
            }
        });

    }


    handleSubmit(event) {
        event.preventDefault();
        var acpt = this.state.edacptcnt;
        if (acpt == 3) {
            this.setState({ loader2: true });
            this.props.mailTravelForm(event).then((data) => {
                this.setState({ loader2: false });

            });
        } else {
            alert('Still approved is pending');
        }


    }

    handleInput(event) {

        let previousLength = this.state.previousLength;
        const bullet = "\u2022";
        const newLength = event.target.value.length;
        const characterCode = event.target.value.substr(-1).charCodeAt(0);
        if (newLength == 1 && previousLength != 0) {
            previousLength = 0;
        }
        if (newLength > previousLength) {
            if (characterCode === 10) {
                event.target.value = `${event.target.value}${bullet} `;
            } else if (newLength === 1) {
                event.target.value = `${bullet} ${event.target.value}`;
            }
        }

        this.setState({
            previousLength: newLength
        });

    }



    addFormFields() {
        var chktotal = this.state.sepmore;
        var totalsep = chktotal + 1;
        this.setState(({
            sepmore: totalsep,
            formValues: [...this.state.formValues, { reasonfortravel: "", numberofdays: "", placetravellingto: "" }]
        }))
    }

    removeFormFields(i) {
        let formValues = this.state.formValues;
        formValues.splice(i, 1);
        this.setState({ formValues });
    }

    handleChange(i, e) {
        
        var totdays=this.state.result;
        let formValues = this.state.formValues;
        formValues[i][e.target.name] = e.target.value;
        
        if(e.target.name=='numberofdays'){

            var exptot=0;

            formValues.forEach(frmval => {
                var numberday=frmval.numberofdays;
                exptot=parseFloat(exptot)+parseFloat(numberday);
            });
         
            if(totdays>=exptot){            
                this.setState({ chkcount:exptot });
                this.setState({ formValues });
            }else{            
                formValues[i][e.target.name] = '';
                this.setState({ formValues });
            }          

        }else{
            this.setState({ formValues });
        }
        
        
    }

    selectdate = (date) => {
        this.setState({ checkoutdate: date });
        this.daysDifference(date, 1);
    }

    selecttime = (event) => {
        var time = event.target.value;
        this.setState({ checkouttime: time });
        this.daysDifference(time, 3);
    }

    selectdatei = (date) => {
        this.setState({ checkindate: date });
        this.daysDifference(date, 2);
    }

    selecttimei = (event) => {
        var time = event.target.value;
        this.setState({ checkintime: time });
        this.daysDifference(time, 4);
    }

    daysDifference(aeldate, pst) {

        if (pst == 1) {
            var checkoutdate = aeldate;
            var checkindate = this.state.checkindate;
            var checkouttime = this.state.checkouttime;
            var checkintime = this.state.checkintime;
        } else if (pst == 2) {
            var checkoutdate = this.state.checkoutdate;
            var checkindate = aeldate;
            var checkouttime = this.state.checkouttime;
            var checkintime = this.state.checkintime;

        } else if (pst == 3) {
            var checkoutdate = this.state.checkoutdate;
            var checkindate = this.state.checkindate;
            var checkouttime = aeldate;
            var checkintime = this.state.checkintime;
        } else {
            var checkoutdate = this.state.checkoutdate;
            var checkindate = this.state.checkindate;
            var checkouttime = this.state.checkouttime;
            var checkintime = aeldate;
        }

        if (checkoutdate != "" && checkouttime != "" && checkindate != "" && checkintime != "") {

            var firstDate = moment(new Date(checkoutdate)).format('YYYY-MM-DD') + ' 00:01';
            var secondDate = moment(new Date(checkindate)).format('YYYY-MM-DD') + ' 00:01';
            var firstTime = moment(new Date(checkoutdate)).format('DD MMMM YYYY') + ' ' + checkouttime;
            var secondTime = moment(new Date(checkindate)).format('DD MMMM YYYY') + ' ' + checkintime;

            var days = this.betweendays(firstDate, secondDate, firstTime, secondTime);

            this.setState({ result: days });

        }
    }

    betweendays(firstDate, secondDate, firstTime, secondTime) {

        var start = new Date(firstDate);
        var end = new Date(secondDate);
        var diff = new Date(end - start);
        var days = diff / 1000 / 60 / 60 / 24 - 1;

        var ftoday = new Date(firstTime);
        var frstcurHr = ftoday.getHours();
        if (frstcurHr >= 0 && frstcurHr < 7) {
            var fminus = 1;
        } else if (frstcurHr >= 7 && frstcurHr < 11) {
            var fminus = '.5';
        } else if (frstcurHr >= 11 && frstcurHr < 24) {
            var fminus = 0;
        }

        var stoday = new Date(secondTime)
        var sedcurHr = stoday.getHours();
        if (sedcurHr >= 0 && sedcurHr < 14) {
            var sminus = 0;
        } else if (sedcurHr >= 14 && sedcurHr < 17) {
            var sminus = '.5';
        } else if (sedcurHr >= 17 && sedcurHr < 24) {
            var sminus = 1;
        }

        var totaldays = parseInt(days) + parseFloat(fminus) + parseFloat(sminus);

        if (Math.sign(totaldays) == '-1') {
            totaldays = 0;
        }

        return totaldays;

    }

    render() {

        const { travelformreport, loading } = this.props;
        const role = localStorage.getItem('user_role');
        const studentname = travelformreport.travel[0].student;

        var acdacpt = '';
        var ssacpt = '';
        var acadacpt = '';
        var partacpt = '';
        if (travelformreport.travel[0].cttf_coachaccept == 1) {
            acdacpt = <strong style={{ color: "green" }}>Accepted</strong>;
        } else if (travelformreport.travel[0].cttf_coachaccept == 2) {
            acdacpt = <span> <strong style={{ color: "red" }}>Rejected</strong> <span style={{ paddingLeft: "20px" }}>Reason :</span> <strong>{travelformreport.travel[0].cttf_coachreason} </strong></span>;
        }

        if (travelformreport.travel[0].cttf_sportsaccept == 1) {
            ssacpt = <strong style={{ color: "green" }}>Accepted</strong>;
        } else if (travelformreport.travel[0].cttf_sportsaccept == 2) {
            ssacpt = <strong style={{ color: "red" }}>Rejected</strong>;
        }

        if (travelformreport.travel[0].cttf_academyaccept == 1) {
            acadacpt = <strong style={{ color: "green" }}>Accepted</strong>;
        } else if (travelformreport.travel[0].cttf_academyaccept == 2) {
            acadacpt = <strong style={{ color: "red" }}>Rejected</strong>;
        }

        if (travelformreport.travel[0].cttf_parentaccept == 1) {
            partacpt = <strong style={{ color: "green" }}>Accepted</strong>;
        } else if (travelformreport.travel[0].cttf_parentaccept == 2) {
            partacpt = <strong style={{ color: "red" }}>Rejected</strong>;
        }

        const styles = {
            buttonProgress: {
                color: "blue",
                position: 'absolute',
                top: '50%',
                marginTop: -15,
                marginLeft: -50,
            },
            buttongreenProgress: {
                color: "green",
                position: 'absolute',
                top: '50%',
                marginTop: -15,
                marginLeft: -80,
            },
            wrapper: {
                position: 'relative',
            },
        };
        return (
            <div>

                <div className="row">
                    <div className="col-sm-12 col-lg-8" style={{ margin: "0 auto" }}>
                        <RctCollapsibleCard heading="Travel Form Details" >
                            <div className="row float-right">
                                <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>
                            </div>



                            <div className="row">

                                <div className="col-sm-12 col-lg-6">
                                    <List className="project-list list-unstyled p-0 ">

                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Name
                                            </span>
                                            <span className="w-50 text-truncate">
                                                : <strong>{studentname}</strong>
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Check_Out Date
                                            </span>
                                            <span className="w-50 text-truncate">
                                                : <strong>{travelformreport.travel[0].cttf_checkoutdate}</strong>
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Check_In Date
                                            </span>
                                            <span className="w-50 text-truncate">
                                                : <strong>{travelformreport.travel[0].cttf_checkindate}</strong>
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Days off from training
                                            </span>
                                            <span className="w-50 text-truncate">
                                                : <strong>{travelformreport.travel[0].cttf_totaldays}</strong>
                                            </span>
                                        </ListItem>

                                    </List>
                                </div>
                                <div className="col-sm-12 col-lg-6">
                                    <List className="project-list list-unstyled p-0 ">

                                        <ListItem className="p-0 d-flex" style={{ height: "18px" }}>
                                            <span className="w-50 d-flex">
                                                {this.state.chklist == 1 ? "" : "dd"}
                                            </span>
                                            <span className="w-50 text-truncate">
                                                {this.state.chklist == 1 ? "" : "dd"}
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Check_Out Time
                                            </span>
                                            <span className="w-50 text-truncate">
                                                : <strong>{travelformreport.travel[0].cttf_checkouttime}</strong>
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Check_In Time
                                            </span>
                                            <span className="w-50 text-truncate">
                                                : <strong>{travelformreport.travel[0].cttf_checkintime}</strong>
                                            </span>
                                        </ListItem>

                                    </List>
                                </div>


                            </div>

                            <div className="row">
                                <table className="table table-bordered" width="100%" >
                                    <thead>
                                        <th width="100">REASON FOR TRAVEL</th>
                                        <th width="100">NUMBER OF DAYS</th>
                                        <th width="100">PLACE TRAVELLING TO</th>
                                    </thead>
                                    <tbody>
                                        {travelformreport.troptions.map((teamval) => (
                                            <tr>
                                                <td> {teamval.ctdy_options}</td>
                                                <td>{teamval.ctdy_days}</td>
                                                <td>{teamval.ctdy_travel}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="col-sm-12 col-lg-8">
                                <List className="project-list list-unstyled p-0 ">

                                    <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                        <span className="w-50 d-flex">
                                            Whom are you travelling with
                                        </span>
                                        <span className="w-50 text-truncate">
                                            : <strong>{travelformreport.travel[0].cttf_towhom}</strong>
                                        </span>
                                    </ListItem>
                                    {travelformreport.travel[0].cttf_towhom == 'Others' ?
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Person Name
                                            </span>
                                            <span className="w-50 text-truncate">
                                                : <strong>{travelformreport.travel[0].cttf_personname}</strong>
                                            </span>
                                        </ListItem>
                                        : ''
                                    }
                                    <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                        <span className="w-50 d-flex">
                                            Mode of transport from campus
                                        </span>
                                        <span className="w-50 text-truncate">
                                            : <strong>{travelformreport.travel[0].cttf_transport}</strong>
                                        </span>
                                    </ListItem>
                                </List>

                            </div>


                            <h3 style={{ marginTop: "20px" }}><strong>Approved By</strong></h3>
                            <div className="row">
                                <div className="col-sm-12 col-lg-6">
                                    <List className="project-list list-unstyled p-0 ">

                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Coaching Team
                                            </span>
                                            <span className="w-50 text-truncate">
                                                :  <strong>{travelformreport.travel[0].cttf_coachname}</strong>
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Sports Science
                                            </span>
                                            <span className="w-50 text-truncate">
                                                :  <strong>{travelformreport.travel[0].cttf_sportsname}</strong>
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Academics
                                            </span>
                                            <span className="w-50 text-truncate">
                                                :  <strong>{travelformreport.travel[0].cttf_academyname}</strong>
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Parent Name
                                            </span>
                                            <span className="w-50 text-truncate">
                                                :  <strong>{travelformreport.travel[0].cttf_parentname}</strong>
                                            </span>
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-sm-12 col-lg-3">
                                    <List className="project-list list-unstyled p-0 ">

                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Status
                                            </span>
                                            <span className="w-50 text-truncate">
                                                :  <strong>{acdacpt}</strong>
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Status
                                            </span>
                                            <span className="w-50 text-truncate">
                                                :  <strong>{ssacpt}</strong>
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Status
                                            </span>
                                            <span className="w-50 text-truncate">
                                                :  <strong>{acadacpt}</strong>
                                            </span>
                                        </ListItem>
                                        <ListItem className="p-0 d-flex justify-content-start align-content-center">
                                            <span className="w-50 d-flex">
                                                Status
                                            </span>
                                            <span className="w-50 text-truncate">
                                                :  <strong>{partacpt}</strong>
                                            </span>
                                        </ListItem>
                                    </List>
                                </div>
                            </div>
                            <div className="col-lg-12" style={{ marginTop: "20px" }}>
                                {role == 4 || role == 39 || role == 8 || role == 11 ?
                                    ""
                                    :
                                    <form autoComplete="off" id="addform" onSubmit={(e) => this.handleSubmit(e)}>
                                        <div>
                                            <FormGroup>
                                                <Label>Parent Mail: (Add more email with comma)</Label>
                                                <textarea className="form-control form-control-alternative" rows="2" id="parentmail" name="parentmail" defaultValue={travelformreport.parentmail}  >
                                                </textarea>
                                            </FormGroup>
                                        </div>
                                        <input type="hidden" name="travelid" id="travelid" value={travelformreport.travel[0].cttfID}></input>
                                        <div className="form-group" style={styles.wrapper}>

                                            <button type="submit" className="mr-3 mb-3 btn btn-outline-success" disabled={this.state.loader2}>Send Mail to Parent</button>
                                            {this.state.loader2 && <CircularProgress size={24} style={styles.buttongreenProgress} />}
                                        </div>
                                    </form>
                                }
                            </div>
                        </RctCollapsibleCard>
                        {role == 4 || role == 39 || role == 8 || role == 11 ?
                            <></>
                            :
                            <RctCollapsibleCard>
                                <h1><center><strong>Academy Check-In Date & Time</strong></center></h1>

                                <div className="row">
                                    <form autoComplete="off" id="updateform" onSubmit={(e) => this.upDateHandleSubmit(e)}>
                                        <div className="row" >
                                            <div className="col-sm-12 col-lg-6 col-xl-6">
                                                <FormGroup>
                                                    <Label for="Email-3">CheckOutDate *</Label>
                                                    <DatePicker className="form-control" id="checkoutdate" name="checkoutdate" autoComplete="off"
                                                        selected={this.state.checkoutdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        onChange={this.selectdate}
                                                    />
                                                </FormGroup>
                                            </div>

                                            <div className="col-sm-12 col-lg-6 col-xl-6">
                                                <FormGroup>
                                                    <Label for="Email-2">CheckOutTime *</Label>
                                                    <input type="time" className="form-control" id="checkouttime" name="checkouttime"
                                                        value={this.state.checkouttime} onChange={this.selecttime}
                                                    ></input>
                                                </FormGroup>
                                            </div>


                                            <div className="col-sm-12 col-lg-6 col-xl-6">
                                                <FormGroup>
                                                    <Label for="Email-3">CheckInDate *</Label>
                                                    <DatePicker className="form-control" id="checkindate" name="checkindate" autoComplete="off" required
                                                        selected={this.state.checkindate}
                                                        onChange={this.selectdatei}
                                                        minDate={this.state.checkoutdate}
                                                        dateFormat='yyyy-MM-dd '
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                    />
                                                </FormGroup>
                                            </div>

                                            <div className="col-sm-12 col-lg-6 col-xl-6">
                                                <FormGroup>
                                                    <Label for="Email-2">CheckInTime *</Label>
                                                    <input type="time" className="form-control" id="checkintime" name="checkintime"
                                                        value={this.state.checkintime}
                                                        onChange={this.selecttimei}
                                                    ></input>

                                                </FormGroup>
                                            </div>

                                            <div className="col-sm-12 col-lg-6 col-xl-6" >
                                                <FormGroup>
                                                    <Label for="Select">Check_in EnterBy</Label>
                                                    <input type="text" name="check in enterby" id="studcheckinenter" className="form-control form-control-alternative" defaultValue={travelformreport.travel[0].cttf_acdyenterby}></input>
                                                </FormGroup>
                                            </div>

                                            <div className="col-sm-12 col-lg-8 col-xl-8">
                                                <FormGroup>
                                                    <Label for="Email-2">Days of Training :   </Label>
                                                    {this.state.result} days
                                                </FormGroup>
                                            </div>

                                            <div className="col-sm-12 col-lg-4 col-xl-4">
                                                <div className="dd">
                                                    <button className="mr-3 mb-3 btn btn-outline-primary float-right" type="button" onClick={() => this.addFormFields()}> <i class="zmdi zmdi-plus-circle-o"></i> addmore</button>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-lg-12 col-xl-12" style={{ border: "1px solid #ccc", padding: "10px", marginBottom: "20px" }}>


                                                {this.state.formValues.map((element, index) => (

                                                    <div className="row" key={index}>
                                                        <div className="col-lg-4">
                                                            
                                                            <FormGroup>
                                                                <Label for="Select">Reason for Travel *</Label>
                                                                <select  name="reasonfortravel" id={"sepopt_"+index} required  className="form-control form-control-alternative" 
                                                    value={element.reasonfortravel || ""} onChange={e => this.handleChange(index, e)}>
                                                        <option value=""> </option>
                                                        <option value="Tournament">Tournament</option>
                                                        <option value="Medical">Medical</option>
                                                        <option value="Personal">Personal</option> 
                                                        <option value="Clubfitting">Club Fitting</option>  
                                                        <option value="Academics">Academics</option>                                               
                                                    </select>
                                                            </FormGroup>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <FormGroup>
                                                                <Label for="Select">Number of Days *</Label>
                                                                <input type="text" name="numberofdays" id={"sepday_" + index} className="form-control form-control-alternative" required
                                                                    value={element.numberofdays || ""} onChange={e => this.handleChange(index, e)} />
                                                            </FormGroup>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <FormGroup>
                                                                <Label for="Select">Place travelling to *</Label>
                                                                <input type="text" name="placetravellingto" id={"septravel_" + index} className="form-control form-control-alternative" required
                                                                    value={element.placetravellingto || ""} onChange={e => this.handleChange(index, e)} />
                                                            </FormGroup>
                                                        </div>
                                                        <div className="col-lg-1">
                                                            {
                                                                index ?
                                                                    <IconButton style={{ width: "10px", height: "10px", marginTop: "30px" }} className="text-danger" aria-label="Remove" onClick={() => this.removeFormFields(index)}  > <DeleteOutlineOutlinedIcon/></IconButton>
                                                                    : null
                                                            }
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>

                                        </div>
                                        <div className="form-group" style={styles.wrapper}>
                                            <input type="hidden" name="upttravelid" id="upttravelid" value={travelformreport.travel[0].cttfID}></input>
                                            <input type="hidden" name="uptstudid" id="uptstudid" value={travelformreport.travel[0].cttf_studentID}></input>

                                            <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" disabled={this.state.loader}>Update</button>
                                            {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}
                                        </div>

                                    </form>
                                </div>
                            </RctCollapsibleCard>
                        }
                    </div>

                </div>


            </div>
        )
    }
}

const mapStateToProps = ({ travelform }) => {
    const { travelformreport, travelformmail, loading } = travelform;
    return { travelformreport, travelformmail, loading };

}

export default connect(mapStateToProps, {


    fetchTravelForm,
    addTravelForm,
    updateTravelForm,
    mailTravelForm

})(UpdateItem);

